"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainflexSchema = void 0;
const zod_1 = require("zod");
const NullableJsonValue_1 = require("../inputTypeSchemas/NullableJsonValue");
const InputJsonValue_1 = require("../inputTypeSchemas/InputJsonValue");
const DataSourceSchema_1 = require("../inputTypeSchemas/DataSourceSchema");
const ChainflexCategorySchema_1 = require("../inputTypeSchemas/ChainflexCategorySchema");
const ArticleSpecSchema_1 = require("../inputTypeSchemas/ArticleSpecSchema");
const ArticleTypeSchema_1 = require("../inputTypeSchemas/ArticleTypeSchema");
const LengthUnitSchema_1 = require("../inputTypeSchemas/LengthUnitSchema");
const WeightPerLengthUnitSchema_1 = require("../inputTypeSchemas/WeightPerLengthUnitSchema");
const AnglePerLengthUnitSchema_1 = require("../inputTypeSchemas/AnglePerLengthUnitSchema");
const TemperatureUnitSchema_1 = require("../inputTypeSchemas/TemperatureUnitSchema");
/////////////////////////////////////////
// CHAINFLEX SCHEMA
/////////////////////////////////////////
exports.ChainflexSchema = zod_1.z.object({
    dataSource: DataSourceSchema_1.DataSourceSchema,
    categories: ChainflexCategorySchema_1.ChainflexCategorySchema.array(),
    articleSpecs: ArticleSpecSchema_1.ArticleSpecSchema.array(),
    articleType: ArticleTypeSchema_1.ArticleTypeSchema,
    chainBendRadiusMinUnit: LengthUnitSchema_1.LengthUnitSchema,
    copperWeightUnit: WeightPerLengthUnitSchema_1.WeightPerLengthUnitSchema.nullish(),
    outerDiameterUnit: LengthUnitSchema_1.LengthUnitSchema,
    weightUnit: WeightPerLengthUnitSchema_1.WeightPerLengthUnitSchema,
    torsionAngleUnit: AnglePerLengthUnitSchema_1.AnglePerLengthUnitSchema.nullish(),
    temperatureMaxUnit: TemperatureUnitSchema_1.TemperatureUnitSchema,
    temperatureMinUnit: TemperatureUnitSchema_1.TemperatureUnitSchema,
    akeneoSku: zod_1.z.string(),
    akeneoUuid: zod_1.z.string().nullish(),
    discontinuedModel: zod_1.z.boolean(),
    echainId: zod_1.z.string(),
    serieRefId: zod_1.z.string(),
    ecfAllowed: zod_1.z.boolean(),
    eicAllowed: zod_1.z.boolean(),
    eiqAllowed: zod_1.z.boolean(),
    ekeAllowed: zod_1.z.boolean(),
    artNr: InputJsonValue_1.InputJsonValue,
    chainBendRadiusMin: zod_1.z.number(),
    copperWeight: zod_1.z.number().nullish(),
    crossSection: NullableJsonValue_1.NullableJsonValue.optional(),
    nominalCrossSection: NullableJsonValue_1.NullableJsonValue.optional(),
    numberOfCores: zod_1.z.string(),
    numberOfCoresCalculated: zod_1.z.number().int().nullish(),
    outerDiameter: zod_1.z.number(),
    ralnumber: zod_1.z.string(),
    weight: zod_1.z.number(),
    busSystem: NullableJsonValue_1.NullableJsonValue.optional(),
    cleanRoom: zod_1.z.boolean(),
    coolantResistant: zod_1.z.boolean(),
    desina: zod_1.z.boolean(),
    dnvGL: zod_1.z.boolean(),
    eac: zod_1.z.boolean(),
    flameRetardant: zod_1.z.boolean(),
    halogenFree: zod_1.z.boolean(),
    mudResistant: zod_1.z.boolean(),
    overallShielding: zod_1.z.boolean(),
    shielding: zod_1.z.boolean(),
    torsionAngle: zod_1.z.number().nullish(),
    torsionable: zod_1.z.boolean(),
    twistedPair: zod_1.z.boolean(),
    ulCsa: zod_1.z.boolean(),
    unshielded: zod_1.z.boolean(),
    uvResistant: zod_1.z.string(),
    temperatureMax: zod_1.z.number(),
    temperatureMin: zod_1.z.number(),
});
exports.default = exports.ChainflexSchema;
//# sourceMappingURL=ChainflexSchema.js.map